<template>
    <section class="about section-padding mt-80">
        <div class="container">
            <h4>{{ $t('Terms of Service') }}</h4>
            <ol>
                <li class="titulo">{{ $t('Acceptance of Terms') }}</li>
                <p class="parrafo">{{ $t('By using') }} <strong>JLHSOFT TECHNOLOGY</strong>{{ $t('services, you agree to these terms and conditions. If you do not agree, please refrain from using our services.') }}</p>
                
                <li class="titulo mt-20">{{ $t('Description of Services') }}</li>
                <p class="parrafo">{{ $t('We provide digital services, including web design and development, digital marketing, web hosting, among others. The details of each service are found in our proposals and contractual agreements.') }}</p>
                
                <li class="titulo mt-20">{{ $t('Use of the Services') }}</li>
                <p class="parrafo">{{ $t('You agree to:') }}</p>
                <ol>
                    <li>{{ $t('Provide accurate and truthful information.') }}</li>
                    <li>{{ $t('Do not use our services for illegal or unauthorized activities.') }}</li>
                </ol>
                <li class="titulo mt-20">{{ $t('Intellectual Property') }}</li>
                <p class="parrafo">{{ $t('All content created by') }} <strong>JLHSOFT TECHNOLOGY</strong> {{ $t('is our property or that of our clients, according to the terms established in each contract.') }}</p>
                
                <li class="titulo mt-20">{{ $t('Limitation of Liability') }}</li>
                <p class="parrafo">{{ $t('We are not responsible for:') }}</p>
                <ol>
                    <li>{{ $t('Damage caused by misuse of our services.') }}</li>
                    <li>{{ $t('Interruptions or failures external to our control.') }}</li>
                </ol>
                <li class="titulo mt-20">{{ $t('Modifications') }}</li>
                <p class="parrafo">{{ $t('We reserve the right to update these terms at any time. Changes will be notified through our website.') }}</p>
                
                <li class="titulo mt-20">{{ $t('Applicable Law') }}</li>
                <p class="parrafo">{{ $t('These terms are governed by the laws of Brasil') }}</p>
            </ol>
        </div>
    </section>
  </template>
  <script>
  export default {
    name: "TermsService",
  };
  </script>
  <style scoped>
  .section-padding h4{
    color: #fff;
    font-size: 25px;
    font-family: 'Poppins', sans-serif;
    font-weight: 600;
    text-align: left;
  }
  .parrafo{
    text-align: justify;
    color: #fff;
  }
  
  ol li{
    color: #fff;
    text-align: left !important;
  }
  
  .titulo{
    color: #fff;
    font-weight: 600;
    text-align: left !important;
  }
  .mt-20{
    margin-top: 20px;
  }
  </style>